export default __webpack_public_path__ + "static/media/help.56057cd8.svg";